import React from "react";
import { useSearchParams } from "react-router-dom";

// ⚠️ Adjust default vs named imports if needed
import { TopNavigation } from "../components/navigation/top-navigation";
import { UserMenu } from "../components/navigation/user-menu";


type ExportTarget = "top-nav" | "user-menu" | "progress-toast" | "audio-player";

interface ExportFrameProps {
  children: React.ReactNode;
}

const ExportFrame: React.FC<ExportFrameProps> = ({ children }) => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#05060A", // or "transparent" if you prefer
      }}
    >
      <div
        style={{
          transform: "scale(1.8)",
          transformOrigin: "top left",
          width: "1200px",
          padding: "40px",
          boxSizing: "border-box",
        }}
      >
        {children}
      </div>
    </div>
  );
};

const TopNavPreview: React.FC = () => (
  <div style={{ width: "100%", maxWidth: 1200 }}>
    <TopNavigation />
  </div>
);

// user: User | null → we can just pass null for export
const UserMenuPreview: React.FC = () => (
  <div
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      padding: "24px",
    }}
  >
    <UserMenu user={null} />
  </div>
);

const ProgressToastPreview: React.FC = () => (
  <div
    style={{
      width: "100%",
      height: 300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >

  </div>
);


const UiExportPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const target = (searchParams.get("target") || "audio-player") as ExportTarget;

  const renderTarget = () => {
    switch (target) {
      case "top-nav":
        return <TopNavPreview />;
      case "user-menu":
        return <UserMenuPreview />;
      case "progress-toast":
        return <ProgressToastPreview />;
      case "audio-player":
      default:

    }
  };

  return <ExportFrame>{renderTarget()}</ExportFrame>;
};

export default UiExportPage;
